import { createContext } from 'react'

import { createLinkCardStore } from '../store/createStore'

export const LinkCardContext = createContext<
  ReturnType<typeof createLinkCardStore> | undefined
>(undefined)
